import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SignupAPIService } from '../../core/services/signup-apiservice';
import { environment } from '../../../environments/environment';
import { TextService } from '../../core/services/text-service';
import { GTMService } from '../../core/services/gtm-service';

@Component({
  selector: 'app-status',
  templateUrl: './status.html',
  styleUrl: './status.scss',
  standalone: false
})
export class Status {
  status = '';
  signupId = '';
  signupPayload: any = null;
  signupFlow: string = 'apps';
  isMock = !environment.production && environment.mockSignup;
  mockStatuses = ['IN_PROGRESS', 'WARNING', 'ERROR', 'DECLINE', 'AWAITING_PFWA_CALLBACK', 'COMPLETE'];

  constructor(
    private route: ActivatedRoute,
    private signupApi: SignupAPIService,
    private router: Router,
    public textService: TextService,
    private gtmService: GTMService
  ) {}

  ngOnInit(): void {
    this.signupId = this.route.snapshot.queryParamMap.get('signupId') ?? '';
  
    const storedPayload = sessionStorage.getItem('signupPayload');
    const storedFlow = sessionStorage.getItem('signupFlow');
  
    if (storedPayload) {
      this.signupPayload = JSON.parse(storedPayload);
    }
    if (storedFlow) {
      this.signupFlow = storedFlow;
    }
  
    if (!this.signupId) {
      this.status = 'ERROR';
      console.error('[Status] Missing signupId in query params');
      return;
    }
  
    if (!this.isMock) {
      this.signupApi.getSignupStatus(this.signupId).subscribe(res => {
        this.status = res.status;
        if(this.status === 'COMPLETE' && !sessionStorage.getItem('gtmSaved')) {
          sessionStorage.setItem('gtmSaved', 'true');
          this.gtmService.signupCompleted();
        }
  
        console.log('[Status] Payload + Status', {
          payload: this.signupPayload,
          status: this.status,
          flow: this.signupFlow
        });
      });
    } else {
      this.status = 'COMPLETE';
      // sessionStorage.setItem('gtmSaved', 'true');
      // this.gtmService.signupCompleted();
    }
  }
  
  setStatus(s: string) {
    this.status = s;
  }

  goHome() {
    // 🔹 Clear session data before going back
    sessionStorage.removeItem('signupPayload');
    sessionStorage.removeItem('signupFlow');
    sessionStorage.removeItem('pfwaSessionInfo');
  
    const current = this.router.url;
    const match = current.match(/\/cloud\/([^/]+)/);
    const subflow = match ? match[1] : null;
  
    if (current.includes('/cloud')) {
      // ✅ Preserve subflow (openstack-flex or sddc-flex)
      const target = subflow
        ? `/cloud/${subflow}/account`
        : '/cloud/account';
      this.router.navigateByUrl(target);
      return;
    }
  
    switch (this.signupFlow) {
      case 'reseller':
        this.router.navigateByUrl('/apps/reseller/account');
        break;
      case 'office365':
        this.router.navigateByUrl('/office365/products');
        break;
      default:
        this.router.navigateByUrl('/apps/products');
        break;
    }
  }
}
